import { ADDRESS_NOT_SHARED_VALUE } from 'platform/shared/health-apps';

export const hasPrimaryCaregiver = formData =>
  formData['view:hasPrimaryCaregiver'] === true;

export const hasSecondaryCaregiverOne = formData =>
  formData['view:hasSecondaryCaregiverOne'] === true;

export const hasSecondaryCaregiverTwo = formData =>
  hasSecondaryCaregiverOne(formData) &&
  formData['view:hasSecondaryCaregiverTwo'] === true;

export const hideCaregiverRequiredAlert = formData => {
  const hasPrimary = hasPrimaryCaregiver(formData);
  const hasSecondary = hasSecondaryCaregiverOne(formData);
  const isSecondaryOneUndefined =
    formData['view:hasSecondaryCaregiverOne'] === undefined;
  return hasPrimary || hasSecondary || isSecondaryOneUndefined;
};

export const hideUploadWarningAlert = formData => {
  const { signAsRepresentativeDocumentUpload: upload } = formData;
  if (!upload) return true;
  const { confirmationCode, name, errorMessage } = upload;
  return !(confirmationCode && name && !errorMessage);
};

export const hasNoSharedAddress = role => formData =>
  formData[`view:${role}SharedAddress`] === ADDRESS_NOT_SHARED_VALUE;

export const hasDifferentMailingAddress = role => formData =>
  formData[`view:${role}HomeSameAsMailingAddress`] === false;
